var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnCheckboxInconCircleActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#CCD9FF",
    fillRule: "nonzero",
    width: 20,
    height: 20,
    rx: 6
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4A77FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m6 10.714 2.571 2.571 5.143-5.142"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnCheckboxInconCircleActive);
export default __webpack_public_path__ + "static/media/btn-checkbox-incon-circle-active.41d5543ba8ffd39b7694a3b48efbe804.svg";
export { ForwardRef as ReactComponent };